import React, { useContext, useEffect, useState } from 'react';
import { Modal, Button, Card, Col } from 'react-bootstrap';
import ToggleSwitch from '../../Components/toogle';
import { UserContext } from '../../Context/UserContext';
import iconAlert from "../../Assets/icons/advertencia.png"
const UserTab: React.FC = () => {
  const { getAllSettings, updateSettings } = useContext(UserContext);
  const [settings, setSettings] = useState<any>({});
  const [currentSetting, setCurrentSetting] = useState<{ name: string; value: any } | null>(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    getSettings();
  }, []);

  const getSettings = async () => {
    let fetchedSettings = await getAllSettings();
    setSettings(fetchedSettings);
  };

  const handleConfirm = async () => {
    if (currentSetting) {
      await updateSettings(currentSetting.name, currentSetting.value);
      getSettings();
      setShowModal(false);
      setCurrentSetting(null);
    }
  };

  const openConfirm = async (name: string, value: any) => {
    if(value != settings.type_link){
    await setCurrentSetting({ name, value });
    setShowModal(true);}
  };

  return (
    <div>
      <Col md={6} className='p-4'>
        <Card style={{  padding: '20px', borderRadius: '10px' }}>
          <Card.Body className=''>
            <p className='text-center'> Changing the switch state will affect all applications to open in the environment specified</p>
            <div className='d-flex justify-content-between'>

            <ToggleSwitch isOnCloud={settings.type_link} setIsOnCloud={openConfirm} />
            <img src={iconAlert} alt="" width={50} />
            </div>
          </Card.Body>
        </Card>
      </Col>

      {/* Confirmation Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body className='text-center'>
          <img src={iconAlert} alt="" width={80} />
          <p>
          Are you sure you want to change the environment?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UserTab;